import { InjectionToken } from '@angular/core';
import { StorageService } from '../core/services/storage/storage.service';
import { UniversalFilesystemService } from '../vas/services/universal-filesystem/universal-filesystem.service';

export const STATE_STORAGE_TOKEN = new InjectionToken<StorageService>("state-storage-token");
export const CHANGE_LOG_STORAGE_TOKEN = new InjectionToken<StorageService>("change-log-storage-token");
export const CHANGE_LOG_UNIVERSAL_FILESYSTEM_TOKEN = new InjectionToken<UniversalFilesystemService>("change-log-universal-filesystem-token");



// WEBPACK FOOTER //
// ./src/app/injection-tokens.ts